{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Créer une nouvelle équipe",
    "HEADER": "Équipes",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "Teams allow you to organize agents into groups based on their responsibilities. An agent can belong to multiple teams. When working collaboratively, you can assign conversations to specific teams.",
    "LEARN_MORE": "Learn more about teams",
    "COUNT": "{n} team | {n} teams",
    "SEARCH_PLACEHOLDER": "Chercher des équipes...",
    "NO_RESULTS": "No teams found matching your search",
    "LIST": {
      "404": "Il n'y a aucune équipe créée sur ce compte.",
      "EDIT_TEAM": "Modifier l'équipe",
      "NONE": "Aucun"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Créer une nouvelle équipe",
        "DESC": "Ajoutez un titre et une description à votre nouvelle équipe."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Ajouter un agent à votre équipe",
        "TITLE": "Ajouter des agents à l'équipe - {teamName}",
        "DESC": "Ajouter des agents à votre équipe nouvellement créée. Cela vous permet de collaborer en équipe sur les conversations, d'être informé des nouveaux événements dans la même conversation."
      },
      "WIZARD_CREATE": {
        "TITLE": "Créer",
        "BODY": "Créer une nouvelle équipe d'agents."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Ajouter des agents",
        "BODY": "Ajouter des agents à l'équipe."
      },
      "WIZARD_FINISH": {
        "TITLE": "Terminer",
        "BODY": "Vous êtes paré !"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Modifier les détails de votre équipe",
        "DESC": "Modifier le titre et la description de votre équipe.",
        "BUTTON_TEXT": "Mettre à jour l'équipe"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Mettre à jour les agents dans l'équipe",
        "TITLE": "Ajouter des agents à l'équipe - {teamName}",
        "DESC": "Ajouter des agents à votre équipe nouvellement créée. Tous les agents ajoutés seront notifiés lorsqu'une conversation est assignée à cette équipe."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Détails de l'équipe",
        "ROUTE": "settings_teams_edit",
        "BODY": "Changer le nom, la description et d'autres détails."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Modifier les agents",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Modifier les agents dans votre équipe."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Terminer",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Vous êtes paré !"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Impossible d'enregistrer les détails de l'équipe. Veuillez réessayer."
    },
    "AGENTS": {
      "AGENT": "Agent",
      "EMAIL": "Courriel",
      "BUTTON_TEXT": "Ajouter des agents",
      "ADD_AGENTS": "Ajout d'agents à votre équipe...",
      "SELECT": "sélectionner",
      "SELECT_ALL": "sélectionner tous les agents",
      "SELECTED_COUNT": "{selected} agents sur {total} sélectionnés."
    },
    "ADD": {
      "TITLE": "Ajouter des agents à l'équipe - {teamName}",
      "DESC": "Ajouter des agents à votre équipe nouvellement créée. Cela vous permet de collaborer en équipe sur les conversations, d'être informé des nouveaux événements dans la même conversation.",
      "SELECT": "sélectionner",
      "SELECT_ALL": "sélectionner tous les agents",
      "SELECTED_COUNT": "{selected} agents sur {total} sélectionnés.",
      "BUTTON_TEXT": "Ajouter des agents",
      "AGENT_VALIDATION_ERROR": "Sélectionnez au moins un agent."
    },
    "FINISH": {
      "TITLE": "Votre équipe est prête !",
      "MESSAGE": "Vous pouvez maintenant collaborer en tant qu'équipe dans les conversations. Bonne assistance ",
      "BUTTON_TEXT": "Terminer"
    },
    "DELETE": {
      "BUTTON_TEXT": "Supprimer",
      "API": {
        "SUCCESS_MESSAGE": "Équipe supprimée avec succès.",
        "ERROR_MESSAGE": "Impossible de supprimer l'équipe. Veuillez réessayer."
      },
      "CONFIRM": {
        "TITLE": "Are you sure you want to delete the team?",
        "PLACE_HOLDER": "Veuillez entrer {teamName} pour confirmer",
        "MESSAGE": "La suppression de l'équipe supprimera les affectations liées aux conversations de cette équipe.",
        "YES": "Supprimer ",
        "NO": "Annuler"
      }
    },
    "SETTINGS": "Paramètres",
    "FORM": {
      "UPDATE": "Mettre à jour l'équipe",
      "CREATE": "Créer une équipe",
      "NAME": {
        "LABEL": "Nom de l'équipe",
        "PLACEHOLDER": "Exemple : Ventes, Support Client"
      },
      "DESCRIPTION": {
        "LABEL": "Description de l'équipe",
        "PLACEHOLDER": "Brève description de cette équipe."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Autoriser l'affectation automatique pour cette équipe."
      },
      "SUBMIT_CREATE": "Créer une équipe"
    }
  }
}
